<template>
    <div class="container-fluid p-medical-courses">
        <div class="card mb-3">
            <div class="card">
                <div class="card-header">{{ $locale.consultation_host }}科一覧</div>
                <div class="card-body p-medical-courses__content">
                    <div class="d-block d-md-flex justify-content-between align-items-center mb-3">
                        <div class="mt-2 mb-2 mb-md-0">
                            <div class="c-freeword input-group input-group-sm">
                                <input
                                    v-model="search.freeword"
                                    @change="onChangeSearchFreeword"
                                    type="text"
                                    class="form-control"
                                    placeholder="フリーワード"
                                    aria-label="Recipient's username"
                                    aria-describedby="basic-addon2">
                                <div class="input-group-append">
                                    <div
                                        class="c-freeword__btn input-group-text" id="basic-addon2"
                                        @click="onChangeSearchFreeword">
                                        検索
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-2 mb-2 mb-md-0">
                            <div class="d-flex justify-content-center align-items-center">
                                <div class="ml-1 mr-1">
                                    <b-button
                                        type="button"
                                        variant="yokumiru-orange"
                                        href="/admin/medical_courses/questions">
                                        {{ $locale.question }}の設定
                                    </b-button>
                                </div>
                                <div class="ml-1 mr-1">
                                    <b-button
                                        type="button"
                                        variant="yokumiru-orange"
                                        @click="openModalAddMedicalCourse">
                                        {{ $locale.consultation_host }}科追加
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div :class="{ 'u-loader u-loader--p5' : ! medicalCourses }">
                        <div v-if="medicalCourses">
                            <b-table
                                striped
                                hover
                                responsive
                                :items="medicalCourses"
                                :fields="fields"
                                :sort-by.sync="$store.state.adminMedicalCourses.sortBy"
                                :sort-desc.sync="$store.state.adminMedicalCourses.sortDesc"
                                @sort-changed="fetchMedicalCourses"
                                class="table-bordered m-table">
                                <template v-slot:cell(name_kana)="data">
                                    <div>{{ data.item.name }}</div>
                                    <div class="small text-muted">{{ data.item.description }}</div>
                                </template>

                                <template v-slot:cell(can_interview_trans)="data">
                                    <div v-if="data.item.can_interview_trans" class="text-success">ON</div>
                                    <div v-else class="text-muted">OFF</div>
                                </template>

                                <template v-slot:cell(can_matching)="data">
                                    <div v-if="data.item.can_matching" class="text-success">ON</div>
                                    <div v-else class="text-muted">OFF</div>
                                </template>

                                <template v-slot:cell(matching_minutes)="data">
                                    <div v-if="data.item.matching_minutes !== null">
                                        <span>{{ data.item.matching_minutes }}</span><!--
                                     --><span class="small">分</span>
                                    </div>
                                </template>

                                <template v-slot:cell(matching_price)="data">
                                    <div v-if="data.item.matching_price !== null">
                                        <span>{{ data.item.matching_price.toLocaleString() }}</span><!--
                                     --><span class="small">円</span>
                                    </div>
                                </template>

                                <template v-slot:cell(is_only_matching)="data">
                                    <div v-if="data.item.is_only_matching" class="text-success">ON</div>
                                    <div v-else class="text-muted">OFF</div>
                                </template>

                                <template v-slot:cell(links)="data">
                                    <div class="d-flex justify-content-end align-items-center">
                                        <select
                                            v-model="data.item.flg_show"
                                            class="form-control form-control-sm selectFlgShow"
                                            :class="{ 'selectFlgShowDisabled' : !canEditFlgShow(data.item) }"
                                            style="width:80px; height:30px;"
                                            :disabled="!canEditFlgShow(data.item)"
                                            @change="updateFlgShow(data.item)">
                                            <option :value="true">表示</option>
                                            <option :value="false">非表示</option>
                                        </select>
                                        <b-button
                                            type="button"
                                            variant="yokumiru-blue"
                                            size="sm"
                                            class="ml-2"
                                            style="width:60px;"
                                            @click="openModalEditMedicalCourse(data.item)">
                                            編集
                                        </b-button>
                                        <b-button
                                            type="button"
                                            variant="danger"
                                            size="sm"
                                            class="ml-2"
                                            style="width:60px;"
                                            :disabled="!deletable(data.item)"
                                            @click="openModalDeleteMedicalCourse(data.item)">
                                            削除
                                        </b-button>
                                    </div>
                                </template>
                            </b-table>

                            <div class="d-flex justify-content-between align-items-center">
                                <b-pagination
                                    :total-rows="$store.state.adminMedicalCourses.total"
                                    :per-page="$store.state.adminMedicalCourses.per_page"
                                    v-model="$store.state.adminMedicalCourses.current_page"
                                    @change="fetchMedicalCourses">
                                </b-pagination>

                                <div class="d-flex flex-wrap align-items-center">
                                    <div class="mb-3 mr-2">
                                        <span class="small">{{ dispPaginationDetail }}</span>
                                    </div>
<!--                                    <div class="mb-3">-->
<!--                                        <b-button-->
<!--                                            variant="yokumiru-orange"-->
<!--                                            @click="downloadCSV"-->
<!--                                            :disabled="inProgress">-->
<!--                                            CSVダウンロード-->
<!--                                        </b-button>-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <admin-add-medical-course-modal/>
        <admin-edit-medical-course-modal/>
        <admin-delete-medical-course-modal/>
        <cannot-delete-medical-course-modal/>
    </div>
</template>

<script>
import constants from '../../constants'
import { mapMutations } from 'vuex'

export default {
    data: function() {
        return {
            medicalCourses: null,
            search: {
                freeword: '',
            },
            fields: [
                {
                    'key': 'id',
                    'label': '#',
                    sortable: true,
                },
                {
                    'key': 'name_kana',
                    'label': `${this.$locale.consultation_host}科名`,
                    sortable: true,
                },
                {
                    'key': 'can_interview_trans',
                    'label': '英語化問診票作成',
                    sortable: true,
                },
                {
                    'key': 'can_matching',
                    'label': 'マッチング予約',
                    sortable: true,
                },
                {
                    'key': 'matching_minutes',
                    'label': `マッチング${this.$locale.consultation_host}時間`,
                    sortable: true,
                },
                {
                    'key': 'matching_price',
                    'label': `マッチング${this.$locale.consultation_host}料 (税別)`,
                    sortable: true,
                },
                {
                    'key': 'is_only_matching',
                    'label': 'マッチング予約のみ表示',
                    sortable: true,
                },
                {
                    'key': 'priority_num',
                    'label': '表示優先度',
                    sortable: true,
                },
                {
                    'key': 'links',
                    'label': '',
                    sortable: false,
                },
            ],
        };
    },

    computed: {
        /**
         * ページング詳細表示
         * @returns {string}
         */
        dispPaginationDetail: function () {
            if ( this.$store.state.adminMedicalCourses.total < 1 ) {
                return ''
            }
            return `全${this.$store.state.adminMedicalCourses.total}件中 ${this.$store.state.adminMedicalCourses.from}～${this.$store.state.adminMedicalCourses.to}件表示`
        },
    },

    created: function () {
        this.initQueryFromState()
        this.initSearchCondition()
        this.fetchMedicalCourses()
        bus.$on('fetch-medical-courses', this.fetchMedicalCourses)
    },

    beforeDestroy: function() {
        bus.$off('fetch-medical-courses')
    },

    methods: {
        ...mapMutations({
            setQuery: 'adminMedicalCourses/setQuery',
            setQueries: 'adminMedicalCourses/setQueries',
        }),

        /**
         * 検索条件の初期化
         */
        initQueryFromState: function () {
            if (localStorage.getItem('yokumiruWeb')) {
                const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                if (data.adminMedicalCourses) {
                    this.setQueries(data.adminMedicalCourses)
                }
            }
        },

        /**
         * 検索条件の初期化
         */
        initSearchCondition: function () {
            this.search.freeword = this.$store.state.adminMedicalCourses.freeword
        },

        onChangeSearchFreeword: async function () {
            await this.setQuery({ key: 'freeword', value: this.search.freeword })
            await this.fetchMedicalCourses(1)
        },

        /**
         * 診療科一覧
         *
         * @param {number|object} param
         */
        fetchMedicalCourses: async function ( param = null ) {
            if (this.inProgress) return
            this.inProgress = true

            this.medicalCourses = null

            if (Number.isInteger(param) && param > 0) {
                await this.setQuery({key: 'current_page', value: param})
            }
            else if (param !== null && param.hasOwnProperty('sortBy')) {
                await this.setQuery({key: 'sortBy', value: param.sortBy})
                await this.setQuery({key: 'sortDesc', value: param.sortDesc})
            }

            const endpoint = constants.admin.medical_courses.endpoint.base

            await axios.get(`${endpoint}${this.buildQuery()}`)
                .then(({data}) => {
                    this.medicalCourses = data.data
                    this.setQuery({key: 'current_page', value: data.current_page})
                    this.setQuery({key: 'per_page', value: data.per_page})
                    this.setQuery({key: 'total', value: data.total})
                    this.setQuery({key: 'from', value: data.from})
                    this.setQuery({key: 'to', value: data.to})
                })

            this.inProgress = false
        },

        /**
         * QueryString生成
         *
         * @param {boolean} paginate
         * @return {string}
         */
        buildQuery: function (paginate = true) {
            let query = '?'

            const state = this.$store.state.adminMedicalCourses

            if (paginate) {
                query += `page=${state.current_page}`
            }
            query += `&sort=${state.sortBy}`
            query += `&desc=${state.sortDesc}`

            if (state.freeword && state.freeword.length > 0) {
                query += `&freeword=${state.freeword}`
            }
            return query
        },

        /**
         * 追加モーダル表示
         */
        openModalAddMedicalCourse: function () {
            bus.$emit('open-modal-add-medical-course')
        },

        /**
         * 編集モーダル表示
         *
         * @param {object} medicalCourse
         */
        openModalEditMedicalCourse: function (medicalCourse) {
            bus.$emit('open-modal-edit-medical-course', medicalCourse)
        },

        /**
         * 削除モーダル表示
         *
         * @param {object} medicalCourse
         */
        openModalDeleteMedicalCourse: function (medicalCourse) {
            if (this.deletable(medicalCourse)) {
                bus.$emit('open-modal-delete-medical-course', medicalCourse)
            }
            else {
                bus.$emit('open-modal-cannot-delete-medical-course')
            }
        },

        /**
         * 相談科の削除可能判定
         */
        deletable: function (medicalCourse) {
            return Number(medicalCourse.flg_deletable) === 1 &&
                medicalCourse.consultations_count < 1 &&
                medicalCourse.doctors_count < 1
        },

        /**
         * 表示／非表示フラグの更新可能判定
         */
        canEditFlgShow: function (medicalCourse) {
            return medicalCourse.consultations_count < 1 &&
                medicalCourse.doctors_count < 1
        },

        /**
         * 表示／非表示フラグの更新
         */
        updateFlgShow: function (medicalCourse) {
            const endpoint = `${constants.admin.medical_courses.endpoint.base}/${medicalCourse.id}`
            axios.put(endpoint, { flg_show: medicalCourse.flg_show })
                .then(() => {
                    bus.$emit('alert-success', '表示状態を切り替えました。')
                })
                .catch(({response}) => {
                    if (response &&
                        response.hasOwnProperty('data') &&
                        response.data.hasOwnProperty('errors') &&
                        response.data.errors.hasOwnProperty('message')) {
                        bus.$emit('alert-danger', response.data.errors.message[0])
                    }
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.selectFlgShow {
    cursor: pointer;
}

.selectFlgShowDisabled {
    cursor: default;
}
</style>

<style lang="scss">
.p-medical-courses__content {
    .b-table {
        min-width: 1400px;

        th, td {
            font-size: 0.75rem;
        }
    }
}
</style>
